import React from 'react';
import PropTypes from 'prop-types';

import { getStep, uploadFiles } from '../../api';

class MeasurementsCurvedC extends React.Component {
  state = {
    upper_bend: null,
  };

  componentDidMount() {
    getStep({ ...this.props.values, step: this.props.step }, this.props.setLoading)
      .then(
        (res) => {
          this.setState({
            upper_bend: res['upper_bend'],
          });
        },
        (error) => {
          console.log(error);
          this.props.setError('generic', error);
        }
      );
  }

  handleInputChange = (e) => {
    const {
      extras: {
        upper_bend,
        ...extras,
      } = {}
    } = this.props.values;
    const value = parseInt(e.target.value, 10) || '';

    this.props.setValue('extended', value);

    if (value) {
      this.props.setValue('extras', {
        ...extras,
        upper_bend: this.state.upper_bend.price.raw,
      });
    } else {
      this.props.setValue('extras', extras);
    }
  };

  handleFilesChange = (e) => {
    const { files } = e.target;

    if (files.length === 0) {
      this.props.setValue('files', []);
    } else {
      uploadFiles(files, this.props.setLoading)
        .then(
          (res) => {
            this.props.setValue('files', res.map((file) => file.url));
          },
          (error) => {
            this.props.setError('generic', error);
          }
        );
    }
  };

  render() {
    const {
      instructions: {
        curved: instructions = {}
      }
    } = window.MTMReact;

    const {
      extended = '',
      files = [],
      lengths,
      stair_type,
    } = this.props.values;

    const lStair = stair_type.indexOf('l') === 0;

    return (
      <React.Fragment>
        {((lStair && lengths.L2 !== 0) || (!lStair && lengths.L3 !== 0)) && (
          <React.Fragment>
            <div className="mtm-instructions" dangerouslySetInnerHTML={{ __html: instructions.extended }} />

            <label>
              Utskjutande upptill, adderar sk. knäböj (mått i mm) {this.state.upper_bend && `+${this.state.upper_bend.price.string}`}
              <input type="number" name="extended" value={extended} onChange={this.handleInputChange} />
            </label>
          </React.Fragment>
        )}

        <div>
          <label htmlFor="mtm-files">Ladda upp bilder eller skisser här om du är osäker på några mått</label>

          <div className="callout">
            <input type="file" id="mtm-files" name="files" multiple accept="image/*" onChange={this.handleFilesChange}/>

            <div>
              {files.map((file) => <img key={file} src={file} width="100" alt="" />)}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MeasurementsCurvedC.propTypes = {
  values: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default MeasurementsCurvedC;





// WEBPACK FOOTER //
// ./src/Step/steps/MeasurementsCurvedC.js